import { useState } from "react";
import { useSnackbar } from "../../core/contexts/SnackbarContext";
import { ApiFactory } from "../../core/config/ApiFactory";
import { ICupom } from "../../pedidos/interface/ICupom";

export const useCupons = () => {
    const [loading, setLoading] = useState(false);
    const snackbar = useSnackbar();
    const apiPedidos = ApiFactory.getApi("MS_PEDIDOS");

    const criar = async (cupom: ICupom) => {
        setLoading(true);
        try {
            const { data } = await apiPedidos.post('/cupons', cupom);
            snackbar("Cupom cadastrado com sucesso", { severity: "success" });
            return data;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || "Ocorreu um erro ao cadastrar o cupom", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    }

    const atualizar = async (uuid: string, cupom: ICupom) => {
        setLoading(true);
        try {
            const { data } = await apiPedidos.put(`/cupons/${uuid}`, cupom);
            snackbar("Cupom atualizado com sucesso", { severity: "success" });
            return data;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || "Ocorreu um erro ao atualizar o cupom", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    }

    const buscar = async (uuid: string) => {
        setLoading(true);
        try {
            const { data } = await apiPedidos.get(`/cupons/${uuid}`);
            return data;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || "Ocorreu um erro ao buscar o cupom", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    }

    const deletar = async (uuid: string) => {
        setLoading(true);
        try {
            await apiPedidos.delete(`/cupons/${uuid}`);
            snackbar("Cupom excluído com sucesso", { severity: "success" });
            return true;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || "Ocorreu um erro ao excluir o cupom", { severity: "error" });
            return false;
        } finally {
            setLoading(false);
        }
    }

    const deletarEmLote = async (uuids: string[]) => {
        setLoading(true);
        try {
            const resultados = [];
            
            for (const uuid of uuids) {
                try {
                    await apiPedidos.delete(`/cupons/${uuid}`);
                    resultados.push({ uuid, sucesso: true });
                } catch (error) {
                    resultados.push({ uuid, sucesso: false, erro: error });
                }
            }
            
            const sucessos = resultados.filter(r => r.sucesso).length;
            const falhas = resultados.filter(r => !r.sucesso).length;
            
            if (falhas > 0) {
                snackbar(`${sucessos} cupom(ns) excluído(s) com sucesso. ${falhas} falha(s).`, { 
                    severity: falhas === uuids.length ? "error" : "warning" 
                });
            } else {
                snackbar(`${sucessos} cupom(ns) excluído(s) com sucesso`, { severity: "success" });
            }
            
            return resultados;
        } catch (error) {
            snackbar("Ocorreu um erro ao excluir os cupons", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    }

    return { criar, atualizar, buscar, deletar, deletarEmLote, loading }
}

